/* EDELHOLZ Konfigurator B - Produktvideos in den Galerien (25.08.2026, umgebaut 07.09.2026).
   Liegt als Asset, weil die Section am Groessenlimit klebt.

   07.09. (Philipp): Bildbuehne und Sektionsbilder verhalten sich EXAKT wie die Kaufbox
   (sections/edelholz-pdp-minikonfigurator.liquid):
   - Schalter "Galerie je Finish" (Section-Setting oder ?galerie=finish): Bilder mit Finish-Tag
     [finish:<slug>] am Ende des Alt-Textes erscheinen nur bei ihrer Holzart, Bild 1 bleibt immer.
   - Video MIT Tag sitzt an seiner Shopify-Medienposition innerhalb der gefilterten Reihe (Philipp
     07.09.: Motiv, Video, Vogelperspektive, ...); Video OHNE Tag wandert ans Ende (ohne Schalter:
     Shopify-Position wie bisher).
   - Wird ein Video-Slide aktiv (Wischen, Pfeil), startet es von selbst - mit Ton, wenn der
     Browser es erlaubt, sonst stumm mit Ton-Knopf. Tap = Pause mit Pausezeichen, Tap = weiter.
     Wegwischen = Pause. Beim Seitenaufruf startet nichts (Slide 1 ist ein Foto).
   - Add-on-Karussells behalten die Regel vom 25.08.: stumm, Autoplay im Viewport, Platz 2. */
(function () {
  'use strict';

  var TAGS = ['golden-timber', 'midnight-noir', 'smoked-amber', 'deep-walnut'];
  var tonGewuenscht = true;

  function slug(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function datei(u) { return String(u || '').split('?')[0].split('/').pop().toLowerCase(); }

  /* Finish-Tag aus Alt-Text (Tag schlaegt Text) oder Dateiname. '' = gilt ueberall. */
  function tagVon(alt, dateiname) {
    var a = String(alt || '');
    var m = a.match(/\[finish:([a-z0-9-]+)\]/i);
    if (m) { var tg = m[1].toLowerCase(); return TAGS.indexOf(tg) > -1 ? tg : ''; }
    var al = a.toLowerCase();
    for (var i = 0; i < TAGS.length; i++) { if (al.indexOf(TAGS[i].replace('-', ' ')) > -1) return TAGS[i]; }
    var d = slug(dateiname || '');
    for (var j = 0; j < TAGS.length; j++) { if (d.indexOf(TAGS[j]) > -1) return TAGS[j]; }
    return '';
  }

  /* Sichtbarkeit: pausiert ein Stage-Video, das aus dem Bild scrollt, und laesst es
     weiterlaufen, wenn es zurueckkommt und nicht vom Kunden angehalten wurde.
     Add-on-Videos (kein data-eh-stage) starten stumm, sobald sie zu sehen sind. */
  var IO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          var v = e.target;
          var stageModus = v.dataset.ehStage === '1';
          if (e.isIntersecting) {
            if (stageModus) {
              if (v.dataset.ehLaeuft === '1' && v.paused && v.dataset.ehPausiert !== '1') API.start(v);
              return;
            }
            if (!v.getAttribute('src') && v.dataset.ehSrc) v.src = v.dataset.ehSrc;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.2 })
    : null;

  function badgeBauen(art) {
    if (art === 'ton') {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'eh-video-ton'; b.hidden = true;
      b.setAttribute('aria-label', 'Ton einschalten');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="m23 9-6 6M17 9l6 6"/></svg>';
      return b;
    }
    var s = document.createElement('span');
    s.className = 'eh-video-pause'; s.hidden = true; s.setAttribute('aria-hidden', 'true');
    s.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>';
    return s;
  }

  /* gross=true: Stage-Zelle -> hoechste Stufe. stageModus=true: Verhalten wie die Kaufbox
     (Start bei Auswahl, Ton, Tap = Pause); sonst Add-on-Regel (stumm, Viewport). */
  function bauen(vid, gross, stageModus) {
    var el = document.createElement('video');
    el.muted = true; el.setAttribute('muted', '');
    el.loop = true;
    el.playsInline = true; el.setAttribute('playsinline', '');
    el.preload = 'none';
    el.className = 'eh-video';
    el.setAttribute('aria-label', vid.alt || 'Produktvideo');
    el.dataset.ehSrc = (gross ? (vid.max || vid.hd || vid.sd) : (vid.sd || vid.hd)) || '';
    el.dataset.ehMax = vid.max || vid.hd || vid.sd || '';
    el.dataset.ehPoster = vid.poster || '';
    el.dataset.ehTag = vid.tag || '';
    el.dataset.ehAlt = vid.alt || '';
    if (vid.poster) el.poster = vid.poster;
    if (stageModus) {
      el.dataset.ehStage = '1';
      /* 15.09.: KEIN src beim Bauen. Chrome hat trotz preload=none das komplette Video (17 MB, hoechste Stufe)
         beim Seitenaufruf geladen, auch mobil, wo die Buehne unsichtbar ist. start() und stageAuswahl() setzen
         src aus data-eh-src, sobald das Video dran ist bzw. der naechste Slide ist. */
    }
    if (IO) IO.observe(el);
    else if (!stageModus) { el.src = el.dataset.ehSrc; el.autoplay = true; }
    return el;
  }

  function zelle(vid, klasse, gross, stageModus) {
    var div = document.createElement('div');
    div.className = klasse;
    div.appendChild(bauen(vid, gross, stageModus));
    if (stageModus) {
      div.style.position = 'relative';
      div.appendChild(badgeBauen('pause'));
      var tb = badgeBauen('ton');
      div.appendChild(tb);
      tb.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        var v = div.querySelector('video.eh-video');
        if (!v) return;
        tonGewuenscht = true;
        v.muted = false;
        if (v.paused) { v.dataset.ehPausiert = ''; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        API.stand(v);
      });
    }
    return div;
  }

  function klemm(n, max) { return Math.max(0, Math.min(n, max)); }

  /* Waechter gegen die Rebuild-Race (siehe 25.08.): Add-on-Karussells, die mit Breite 0
     layoutet wurden, einmal heilen. Unveraendert. */
  var heilRunden = 0, heilTimer = null;
  function heilPruefe() {
    var offen = false;
    try {
      document.querySelectorAll('.eh-feature-img.flickity-enabled').forEach(function (k) {
        if (!k.querySelector('video.eh-video')) return;
        var fl = window.Flickity && window.Flickity.data(k);
        if (!fl || !fl.isActive) return;
        var breite = k.getBoundingClientRect().width;
        if (breite < 1) { offen = true; return; }
        if (!fl.size || fl.size.innerWidth < 1) {
          try { fl.resize(); fl.selectCell(0, false, true); } catch (e) {}
        }
      });
    } catch (e) {}
    if ((offen || heilRunden < 20) && ++heilRunden < 40) {
      heilTimer = setTimeout(heilPruefe, 400);
    } else { heilTimer = null; }
  }
  function heilStart() {
    heilRunden = 0;
    if (!heilTimer) heilPruefe();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', heilStart, { once: true });
  } else { heilStart(); }

  var API = {
    daten: { models: {}, addons: {}, alts: {}, galFinish: false },

    laden: function (sectionId) {
      try {
        var n = document.getElementById('ehb-videos-' + sectionId);
        if (n) API.daten = JSON.parse(n.textContent) || API.daten;
      } catch (e) { /* ohne Daten laufen die Galerien wie bisher nur mit Bildern */ }
      return API.daten;
    },

    galFinishAn: function () {
      if (API.daten.galFinish === true) return true;
      try { return /(^|[?&])galerie=finish(&|$)/.test(location.search); } catch (e) { return false; }
    },

    modellVideos: function (key) {
      return ((API.daten.models || {})[key] || []).map(function (v) {
        if (v.tag === undefined) v.tag = tagVon(v.alt, v.max || v.hd || v.sd);
        return v;
      });
    },
    addonVideos: function (key) { return (API.daten.addons || {})[key] || []; },

    /* Bilder einer Variante nach Holzart filtern. Index 0 (Variantenbild) bleibt immer.
       Ohne Schalter oder ohne Holzart: unveraendert. */
    /* alts[datei] ist ["Alt-Text", Medienposition] (Snippet ehb-galerie-alts), aeltere Form: String. */
    altVon: function (modelKey, d) { var e = ((API.daten.alts || {})[modelKey] || {})[d]; return Array.isArray(e) ? e[0] : (e || ''); },
    posVon: function (modelKey, d) { var e = ((API.daten.alts || {})[modelKey] || {})[d]; return Array.isArray(e) ? (+e[1] || 0) : 0; },
    letztePositionen: [],
    bilderFiltern: function (urls, finishName, modelKey) {
      API.letztePositionen = (urls || []).map(function (u) { return API.posVon(modelKey, datei(u)); });
      if (!API.galFinishAn() || !finishName || !urls) return urls;
      var want = slug(finishName);
      var out = [], pos = [];
      urls.forEach(function (u, i) {
        var d = datei(u);
        var tg = i === 0 ? '' : tagVon(API.altVon(modelKey, d), d);
        if (i === 0 || !tg || tg === want) { out.push(u); pos.push(API.posVon(modelKey, d)); }
      });
      API.letztePositionen = pos;
      return out;
    },
    /* Ziel-Index eines getaggten Videos in der gefilterten Reihe: hinter allen Bildern,
       deren Medienposition kleiner ist. Ohne Positionsdaten: Platz 2. */
    videoIndex: function (v, anzahl) {
      var p = +v.pos || 0;
      var pos = API.letztePositionen || [];
      if (!p || !pos.length) return klemm(1, anzahl);
      var n = 1;
      for (var i = 1; i < pos.length; i++) { if (pos[i] && pos[i] < p) n++; }
      return klemm(n, anzahl);
    },

    /* Video-Zellen in eine frische Stage-Zellenliste einsortieren.
       Mit Schalter: Video mit Tag der Holzart -> Platz 2, Video ohne Tag -> Ende,
       Videos anderer Holzarten -> gar nicht. Ohne Schalter: Shopify-Position wie bisher. */
    stageMischen: function (zellen, vids, finishName) {
      var an = API.galFinishAn();
      var want = slug(finishName);
      var eingesetzt = 0;
      (vids || []).forEach(function (v) {
        if (!an) { zellen.splice(klemm((v.pos || 99) - 1, zellen.length), 0, zelle(v, 'eh-visual-cell', true, true)); return; }
        if (v.tag && v.tag !== want) return;
        if (v.tag) { zellen.splice(API.videoIndex(v, zellen.length) + eingesetzt, 0, zelle(v, 'eh-visual-cell', true, true)); eingesetzt++; }
        else zellen.push(zelle(v, 'eh-visual-cell', true, true));
      });
      return zellen;
    },

    /* Initialzustand: in das bereits initialisierte Stage-Flickity einsetzen. */
    stageStart: function (carousel, vids, finishName) {
      var an = API.galFinishAn();
      var want = slug(finishName);
      var eingesetzt = 0;
      (vids || []).forEach(function (v) {
        try {
          if (!an) { carousel.insert(zelle(v, 'eh-visual-cell', true, true), klemm((v.pos || 99) - 1, carousel.cells.length)); return; }
          if (v.tag && v.tag !== want) return;
          if (v.tag) { carousel.insert(zelle(v, 'eh-visual-cell', true, true), API.videoIndex(v, carousel.cells.length) + eingesetzt); eingesetzt++; }
          else carousel.append(zelle(v, 'eh-visual-cell', true, true));
        } catch (e) {}
      });
    },

    /* ---- Abspielen wie in der Kaufbox ---- */
    stand: function (v) {
      var host = v.parentElement; if (!host) return;
      var pb = host.querySelector('.eh-video-pause'), tb = host.querySelector('.eh-video-ton');
      if (pb) pb.hidden = !(v.paused && v.dataset.ehGestartet === '1');
      if (tb) tb.hidden = !(!v.paused && v.muted);
    },
    start: function (v) {
      if (!v) return;
      if (!v.getAttribute('src') && v.dataset.ehSrc) v.src = v.dataset.ehSrc;
      v.preload = 'auto';
      v.loop = true; v.playsInline = true;
      v.dataset.ehGestartet = '1'; v.dataset.ehLaeuft = '1'; v.dataset.ehPausiert = '';
      var spiel = function (mitTon) {
        v.muted = !mitTon;
        var pr; try { pr = v.play(); } catch (e) { pr = Promise.reject(e); }
        return (pr && pr.then) ? pr : Promise.resolve();
      };
      spiel(tonGewuenscht).catch(function () { return spiel(false); }).catch(function () {}).then(function () { API.stand(v); });
    },
    stopp: function (v) {
      if (!v) return;
      v.dataset.ehLaeuft = '';
      if (!v.paused) v.pause();
      API.stand(v);
    },
    toggle: function (v) {
      if (!v) return;
      if (v.paused) { API.start(v); }
      else { v.dataset.ehPausiert = '1'; v.pause(); API.stand(v); }
    },
    /* Flickity 'select': aktives Video starten, alle anderen anhalten, das naechste vorladen. */
    stageAuswahl: function (carousel) {
      try {
        var sel = carousel.selectedElement;
        var cells = carousel.cells.map(function (c) { return c.element; });
        cells.forEach(function (c) {
          var v = c.querySelector('video.eh-video[data-eh-stage]');
          if (!v) return;
          if (c === sel) API.start(v); else API.stopp(v);
        });
        /* 15.09.: Das naechste Video nur vorladen, wenn der Kunde schon in der Buehne blaettert
           (selectedIndex > 0). Vorher lief das schon beim Seitenaufbau (Flickity 'select' beim Einsetzen)
           und zog das komplette Video (17 MB) - auch mobil, wo die Buehne unsichtbar ist. */
        if (carousel.selectedIndex < 1) return;
        var n = cells[carousel.selectedIndex + 1];
        var nv = n && n.querySelector('video.eh-video[data-eh-stage]');
        if (nv) { if (!nv.getAttribute('src') && nv.dataset.ehSrc) nv.src = nv.dataset.ehSrc; nv.preload = 'auto'; }
      } catch (e) {}
    },
    /* Flickity 'staticClick' auf die aktive Zelle: Pause / weiter. */
    stageTap: function (carousel) {
      try {
        var sel = carousel.selectedElement;
        var v = sel && sel.querySelector('video.eh-video[data-eh-stage]');
        if (v) API.toggle(v);
        return !!v;
      } catch (e) { return false; }
    },

    /* Add-on-Karussell: unveraendert (Videos auf Platz 2, stumm, Viewport-Autoplay). */
    addonEinsetzen: function (carousel, vids) {
      if (!vids || !vids.length) return;
      vids.forEach(function (v, i) {
        try {
          carousel.insert(zelle(v, 'eh-feature-img-cell', false, false),
            Math.min(1 + i, carousel.cells.length));
        } catch (e) {}
      });
      var fertig = function () {
        try {
          carousel.reloadCells(); carousel.resize();
          carousel.selectCell(0, false, true);
        } catch (e) {}
      };
      fertig();
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function (es) {
          if (es[0] && es[0].contentRect.width > 0) { ro.disconnect(); fertig(); }
        });
        ro.observe(carousel.element);
      }
      heilStart();
      var offen = [].slice.call(carousel.element.querySelectorAll('img'))
        .filter(function (i) { return !i.complete; });
      var rest = offen.length;
      offen.forEach(function (i) {
        var done = function () { if (--rest === 0) fertig(); };
        i.addEventListener('load', done, { once: true });
        i.addEventListener('error', done, { once: true });
      });
    },

    /* ehb-bild-Spiegel (mobil): Video im Kasten zeigen und wie in der Kaufbox starten. */
    boxZeigen: function (box, eintrag) {
      var stage = box.querySelector('.ehb-bild__stage');
      var img = box.querySelector('.ehb-bild__img');
      if (!stage) return;
      var alt = stage.querySelector('video.eh-video');
      if (alt && alt.dataset.ehSrc === (eintrag.max || eintrag.sd)) {
        if (img) img.style.display = 'none';
        if (alt.paused && alt.dataset.ehPausiert !== '1') API.start(alt);
        return;
      }
      API.boxLeeren(box);
      var z = zelle({ sd: eintrag.sd, hd: eintrag.max || eintrag.sd, max: eintrag.max || eintrag.sd, poster: eintrag.poster, alt: eintrag.alt, tag: eintrag.tag }, 'eh-video-box', true, true);
      z.setAttribute('data-eh-video-box', '');
      stage.appendChild(z);
      if (img) img.style.display = 'none';
      var v = z.querySelector('video.eh-video');
      z.addEventListener('click', function (e) { if (e.target.closest('.eh-video-ton')) return; API.toggle(v); });
      API.start(v);
    },

    /* ... bzw. wieder entfernen (zurueck zum Bild). */
    boxLeeren: function (box) {
      var stage = box.querySelector('.ehb-bild__stage');
      var img = box.querySelector('.ehb-bild__img');
      var alt = stage && stage.querySelector('[data-eh-video-box]');
      if (alt) {
        var v = alt.querySelector('video.eh-video');
        if (v) { if (IO) { try { IO.unobserve(v); } catch (e) {} } try { v.pause(); } catch (e) {} }
        alt.remove();
      }
      if (img) img.style.display = '';
    }
  };

  window.EHBVideo = API;
})();
